<div class="storage-intro">
    <qpx-hero-icon
        name="lucideHardDrive"
        context="destructive"
        tone="muted"
        [active]="true"
    />
    <strong qpxBody="destructive" tone="muted" size="md" class="font-semibold">
        {{ isFull() ? 'Storage full' : 'Storage almost full' }}
    </strong>
</div>
<div class="storage-actions">
    <qpx-document-storage-usage
        context="destructive"
        label="Document storage"
        [mini]="true"
        [storageUsage]="storageUsage()"
    />
    @if (contactUsHref; as href) {
        <a qpxButton matButton="filled" context="card" size="sm" [href]="href">
            <ng-icon qpx name="lucideMail" size="sm" matButtonIcon />
            <span>Contact us</span>
        </a>
    }
</div>
